// eslint-disable-next-line import/prefer-default-export
export const setStudyType = studyType => {
  return {
    type: 'SET_STUDY_TYPE',
    payload: {
      studyType,
    },
  };
};
